import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
export function Footer() {
  const {
    currentEra
  } = useTheme();
  // Era-specific footer styles
  const getFooterBorderStyles = () => {
    switch (currentEra) {
      case '60s':
        return 'border-t-2 border-black pt-6';
      case '70s':
        return 'border-t-2 border-amber-800 pt-6';
      case '80s':
        return 'border-t-2 border-dashed border-pink-500 pt-6';
      case '90s':
        return 'border-t-2 border-dashed border-pink-500 pt-6';
      case '2000s':
        return 'border-t-2 border-blue-600 pt-6';
      default:
        return 'border-t-2 border-dashed border-pink-500 pt-6';
    }
  };
  // Era-specific magazine title styles
  const getMagazineTitleStyles = () => {
    switch (currentEra) {
      case '60s':
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" data-id="element-55">
            <span className="text-black" data-id="element-56">RE</span>
            <span className="text-black" data-id="element-57">VOLT</span>
          </h2>;
      case '70s':
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" data-id="element-58">
            <span className="text-amber-800" data-id="element-59">RE</span>
            <span className="text-amber-600" data-id="element-60">VOLT</span>
          </h2>;
      case '80s':
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" style={{
          textShadow: '1px 1px 0 #00ffff, -1px -1px 0 #ff00ff'
        }} data-id="element-61">
            <span className="text-yellow-300" data-id="element-62">RE</span>
            <span className="text-cyan-400" data-id="element-63">VOLT</span>
          </h2>;
      case '90s':
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" data-id="element-64">
            <span className="text-cyan-400" data-id="element-65">RE</span>
            <span className="text-pink-500" data-id="element-66">VOLT</span>
          </h2>;
      case '2000s':
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" data-id="element-67">
            <span className="text-blue-600" data-id="element-68">RE</span>
            <span className="text-orange-500" data-id="element-69">VOLT</span>
          </h2>;
      default:
        return <h2 className="text-2xl font-bold tracking-tighter uppercase" data-id="element-70">
            <span className="text-cyan-400" data-id="element-71">RE</span>
            <span className="text-pink-500" data-id="element-72">VOLT</span>
          </h2>;
    }
  };
  // Era-specific footer text styles
  const getFooterTextStyles = () => {
    switch (currentEra) {
      case '60s':
        return 'text-sm text-black';
      case '70s':
        return 'text-sm text-amber-800';
      case '80s':
        return 'text-sm text-gray-400';
      case '90s':
        return 'text-sm text-gray-400';
      case '2000s':
        return 'text-sm text-gray-600';
      default:
        return 'text-sm text-gray-400';
    }
  };
  // Era-specific footer established year
  const getEstablishedYear = () => {
    switch (currentEra) {
      case '60s':
        return 'Est. 1962';
      case '70s':
        return 'Est. 1972';
      case '80s':
        return 'Est. 1982';
      case '90s':
        return 'Est. 1992';
      case '2000s':
        return 'Est. 2002';
      default:
        return 'Est. 1992';
    }
  };
  // Era-specific footer shape styles
  const getFooterShapeStyles = (type: string) => {
    switch (currentEra) {
      case '60s':
        return type === 'first' ? 'w-10 h-10 bg-black mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-black rotate-45 mx-auto mb-2' : 'w-10 h-10 bg-black mx-auto mb-2';
      case '70s':
        return type === 'first' ? 'w-10 h-10 bg-amber-600 rounded-full mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-amber-800 rounded-full mx-auto mb-2' : 'w-10 h-10 bg-amber-700 rounded-full mx-auto mb-2';
      case '80s':
        return type === 'first' ? 'w-10 h-10 bg-yellow-400 mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-pink-500 rotate-12 mx-auto mb-2' : 'w-10 h-10 bg-cyan-400 mx-auto mb-2';
      case '90s':
        return type === 'first' ? 'w-10 h-10 bg-yellow-400 rotate-45 mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-pink-500 rotate-12 mx-auto mb-2' : 'w-10 h-10 bg-cyan-400 mx-auto mb-2';
      case '2000s':
        return type === 'first' ? 'w-10 h-10 bg-orange-500 rounded mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-blue-600 rounded mx-auto mb-2' : 'w-10 h-10 bg-green-500 rounded mx-auto mb-2';
      default:
        return type === 'first' ? 'w-10 h-10 bg-yellow-400 rotate-45 mx-auto mb-2' : type === 'second' ? 'w-10 h-10 bg-pink-500 rotate-12 mx-auto mb-2' : 'w-10 h-10 bg-cyan-400 mx-auto mb-2';
    }
  };
  return <footer className="mt-12 mb-8" data-id="element-73">
      <div className={getFooterBorderStyles()} data-id="element-74">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-75">
          <div className="mb-4 md:mb-0" data-id="element-76">
            {getMagazineTitleStyles()}
            <p className={getFooterTextStyles()} data-id="element-77">
              {currentEra === '60s' ? 'Underground Press' : currentEra === '70s' ? 'Liberation Journal' : currentEra === '80s' ? 'Queer Power Press' : currentEra === '90s' ? 'Queer Power Press' : 'Digital Queer Media'}{' '}
              • {getEstablishedYear()}
            </p>
          </div>
          <div className="flex gap-6" data-id="element-78">
            <div className="text-center" data-id="element-79">
              <div className={getFooterShapeStyles('first')} data-id="element-80"></div>
              <p className={`text-xs uppercase ${currentEra === '60s' ? 'text-black' : currentEra === '70s' ? 'text-amber-900' : currentEra === '80s' ? 'text-white' : currentEra === '90s' ? 'text-white' : 'text-gray-700'}`} data-id="element-81">
                Distribute
              </p>
            </div>
            <div className="text-center" data-id="element-82">
              <div className={getFooterShapeStyles('second')} data-id="element-83"></div>
              <p className={`text-xs uppercase ${currentEra === '60s' ? 'text-black' : currentEra === '70s' ? 'text-amber-900' : currentEra === '80s' ? 'text-white' : currentEra === '90s' ? 'text-white' : 'text-gray-700'}`} data-id="element-84">
                Subscribe
              </p>
            </div>
            <div className="text-center" data-id="element-85">
              <div className={getFooterShapeStyles('third')} data-id="element-86"></div>
              <p className={`text-xs uppercase ${currentEra === '60s' ? 'text-black' : currentEra === '70s' ? 'text-amber-900' : currentEra === '80s' ? 'text-white' : currentEra === '90s' ? 'text-white' : 'text-gray-700'}`} data-id="element-87">
                Connect
              </p>
            </div>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-gray-400" data-id="element-88">
          <p className={currentEra === '60s' ? 'text-black' : currentEra === '70s' ? 'text-amber-900' : currentEra === '80s' ? 'text-gray-400' : currentEra === '90s' ? 'text-gray-400' : 'text-gray-600'} data-id="element-89">
            This publication is produced by and for the community. Copy and
            distribute freely.
          </p>
          <p className={`mt-1 ${currentEra === '60s' ? 'text-black' : currentEra === '70s' ? 'text-amber-900' : currentEra === '80s' ? 'text-gray-400' : currentEra === '90s' ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-90">
            No copyright. No hierarchy. Just solidarity.
          </p>
        </div>
      </div>
    </footer>;
}